import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TMassPostSaleJobsApi } from './types';

export const massPostSaleJobs: TMassPostSaleJobsApi = {
	getJobs: (payload) =>
		http.post(endpoint.massPostSaleJobs.JOBS, payload).then((response) => response.data),
	getJobOrders: (payload) =>
		http.post(endpoint.massPostSaleJobs.ORDERS, payload).then((response) => response.data),
};
